import React, { useState, useRef, useEffect } from 'react';
import { IoIosArrowDown  } from "react-icons/io"
import styles from '../../styles/Components/Shared/SearchDropdown.module.css';


const SelectDropdown  = ({ 
    options, 
    handleSelect, 
    placeholder, 
    selection,
    nameIsValue, 
    handleSearch, 
    emptyOption, 
    blueBorder, 
    darkText, 
    clear, 
    disabled, 
    disableFilter, 
    maxHeight,
    dropDownAbove,
    returnData,
 }) => { 
    // const [searchTerm, setSearchTerm] = useState('')
    const [selected, setSelected] = useState(null)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [close, setClose] = useState(0)
    const searchRef = useRef(null)
    const inputRef = useRef(null)
    
    const handleClick = (option, i) => {
        // handleSelect(nameIsValue ? option.name : option.value, option.name)
        handleSelect(returnData ? option.data : nameIsValue ? option.name : option.value, option.name)
        setSelectedIndex(i)
        setClose(close + 1)
    }

    const handleKeyPress = (e) => {
        if (e?.key === 'ArrowDown' && selectedIndex < options.length - 1) {
            if (searchRef.current) {
                searchRef.current.scrollIntoView()

            }
            
            const newIndex = selectedIndex + 1

            if (options && options[newIndex]) {
                handleSelect(nameIsValue ? options[newIndex].name : options[newIndex].value, options[newIndex].name)
            }

            return setSelectedIndex(newIndex)
        } else if (e?.key === 'ArrowUp' && selectedIndex > 0) {
            if (searchRef.current) {
                searchRef.current.scrollIntoView({ block: 'center'})
            }

            const newIndex = selectedIndex - 1

            if (options && options[newIndex]) {
                handleSelect(nameIsValue ? options[newIndex].name : options[newIndex].value, options[newIndex].name)
            }

            return setSelectedIndex(newIndex)
        } else if (e?.key === 'Enter') {
            setClose(close + 1)
            inputRef.current.blur()
        }
    }

    useEffect(() => {
        
        if (selection !== null) {
            const foundIndex = options?.findIndex(e => nameIsValue ? e.name === selection :  e.value == selection)
   
            if (foundIndex !== -1) {
                setSelected(options[foundIndex].name)
                setSelectedIndex(foundIndex)
            }
        } else {
            setSelected(null)
        }
    }, [selection, options])
    
    return  (
        <div  >
            <input 
                className={`${blueBorder ? 'input' : 'input_basic'} ${styles.search_dropdown} ${styles.select_dropdown} ${darkText ? styles.dark_text : ''}`} 
                type='text'
                disabled={disabled ? true : false}
                placeholder={selected !== null ? selected : placeholder ? placeholder : `Select`}
                autoComplete='off'
                value={''}
                onChange={(e) => {}}
                onKeyDown={(e) => handleKeyPress(e) }
                ref={inputRef}
                />
                <div className={`${styles.search_dropdown_container} ${styles.select_dropdown_container} ${dropDownAbove ? styles.search_dropdown_container_above : ''}`} key={close} style={maxHeight ? { maxHeight } : {}}>
                    {options?.length > 0 ? options.map((option, i) =>  (
                            <p key={`option-${i}`} id={option.name} onClick={() => handleClick(option, i)} ref={i === selectedIndex ? searchRef : null}  className={i === selectedIndex ? styles.selected : ''}>{option.name}</p>
                        ))
                    : emptyOption ? 
                        <p className={styles.empty_option}>{emptyOption}</p>
                    : null}

                </div>
                {disabled ? null : <p className={styles.dropdown_arrow} onClick={() => inputRef.current?.focus()}><IoIosArrowDown size={20} /></p>}
        </div>
    ) 
}
export default SelectDropdown;